import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanDeactivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { LikutFinishComponent } from '../components/likut-finish/likut-finish.component';
import { LikutTaskComponent } from '../components/likut-task/likut-task.component';
import { LikutService } from '../services/likut.service';
import { TruckDistributionService } from '../services/truck-distribution.service';
import { TruckLoadingService } from '../services/truck-loading.service';

type ComponentType = LikutTaskComponent | LikutFinishComponent;

@Injectable({
	providedIn: 'root',
})
export class CantExitTruckOrLikutGuard implements CanDeactivate<ComponentType> {
	private _likut = inject(LikutService);
	private _router = inject(Router);
	private _truckLoading = inject(TruckLoadingService);
	private _truckDistribution = inject(TruckDistributionService);
	constructor() {}

	canDeactivate(
		component: ComponentType,
		currentRoute: ActivatedRouteSnapshot,
		currentState: RouterStateSnapshot,
		nextState?: RouterStateSnapshot,
	): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
		if (
			(this._likut.likutOpenedNewRoutesState.sub.length || this._truckLoading.truckLoadOpened.sub.length || this._truckDistribution.truckDistributionOpened.sub.length) &&
			!nextState.url.includes('finish')
		) {
			this._router.navigate([currentState.url.slice(1)]);

			return false;
		}

		return true;
	}
}
